import React from 'react';
import PropTypes from 'prop-types';
import AsyncCommentPane from '@99designs/common/apps/ddo/components/AsyncCommentPane';
import { Button } from '@99designs/common/components/Button';
import DesignMetadata from './DesignMetadata';
import TrackClick from 'components/TrackClick';

export default class DefaultSidebarBody extends React.Component {
    marketingButton() {
        if (!this.props.design.marketingCtaButton) return null;

        return (
            <TrackClick
                event="Element Clicked On Design Overlay"
                element="secondary_cta"
                payload={{ targetUrl: this.props.design.marketingCtaButton.url }}
            >
                <Button
                    variations={['fluid', 'secondary']}
                    href={this.props.design.marketingCtaButton.url}
                >
                    {this.props.design.marketingCtaButton.text}
                </Button>
            </TrackClick>
        );
    }

    commentSection() {
        if (!this.props.design.permission.userIdentified) return null;

        return (
            <AsyncCommentPane
                design={this.props.design}
                activeUser={this.props.activeUser}
                isLoadingComments={this.props.isLoadingComments}
                comments={this.props.comments}
                selectedComment={this.props.selectedComment}
                selectedCommentStatus={this.props.selectedCommentStatus}
                selectedCommentEditingLocation={this.props.selectedCommentEditingLocation}
            />
        );
    }

    // FIXME: sidebar-body isn't wrapping the whole sidebar body
    render() {
        return (
            <div>
                <div className="sidebar-body">
                    <DesignMetadata design={this.props.design} />
                    {this.marketingButton()}
                </div>
                {this.commentSection()}
            </div>
        );
    }
}

DefaultSidebarBody.propTypes = {
    design: PropTypes.shape({
        permission: PropTypes.shape({
            userIdentified: PropTypes.bool.isRequired,
        }),
        marketingCtaButton: PropTypes.shape({
            text: PropTypes.string,
            url: PropTypes.string,
        }),
    }).isRequired,
    activeUser: PropTypes.object,
    isLoadingComments: PropTypes.bool,
    comments: PropTypes.any,
    selectedComment: PropTypes.any,
    selectedCommentEditingLocation: PropTypes.any,
    selectedCommentStatus: PropTypes.any,
};



// WEBPACK FOOTER //
// ./src/js/apps/ddo/components/DefaultSidebarBody.jsx